import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const feedsRequest = createAction(types.FEEDS_REQUEST);
export const feedsSuccess = createAction(types.FEEDS_SUCCESS);
export const feedsFailure = createAction(types.FEEDS_FAILURE);

export const feedRequest = createAction(types.FEED_REQUEST);
export const feedSuccess = createAction(types.FEED_SUCCESS);
export const feedFailure = createAction(types.FEED_FAILURE);

export const createFeedRequest = createAction(types.CREATE_FEED_REQUEST);
export const createFeedSuccess = createAction(types.CREATE_FEED_SUCCESS);
export const createFeedFailure = createAction(types.CREATE_FEED_FAILURE);

export const updateFeedRequest = createAction(types.UPDATE_FEED_REQUEST);
export const updateFeedSuccess = createAction(types.UPDATE_FEED_SUCCESS);
export const updateFeedFailure = createAction(types.UPDATE_FEED_FAILURE);

export const deleteFeedRequest = createAction(types.DELETE_FEED_REQUEST);
export const deleteFeedSuccess = createAction(types.DELETE_FEED_SUCCESS);
export const deleteFeedFailure = createAction(types.DELETE_FEED_FAILURE);

export const resetFeed = createAction(types.RESET_FEED);

export default {
  resetFeed,
  feedsRequest,
  feedsSuccess,
  feedsFailure,
  feedRequest,
  feedSuccess,
  feedFailure,
  createFeedRequest,
  createFeedSuccess,
  createFeedFailure,
  updateFeedRequest,
  updateFeedSuccess,
  updateFeedFailure,
  deleteFeedRequest,
  deleteFeedSuccess,
  deleteFeedFailure,
};
